/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { arrayOf, func, number, shape } from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import { Divider, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

import { useUserRolePermissions } from 'hooks';

const OpenPtosMobileMenuItems = ({
  affiliateListDropdown,
  filterCount,
  handleClickViewClosed,
  handleClickViewList,
  locations,
  numberFuturePtos,
  onCreateNew,
  setFilterDrawerOpen,
}) => {
  const { spacing, typography } = useTheme();

  const [moreActive, setMoreActive] = useState(false);
  const [anchor, setAnchor] = useState(null);

  const navigate = useNavigate();

  const { isProductOwnerManage, isInventoryOwner } = useUserRolePermissions();
  const disableFilterButton =
    locations.length <= 2 && numberFuturePtos === 0 && affiliateListDropdown.length <= 2;

  return (
    <Toolbar disableGutters sx={{ minHeight: 56, top: 56 }} variant="toolbar-button-menu">
      {isProductOwnerManage && isInventoryOwner && (
        <MenuItem
          component="button"
          label="Add new"
          onClick={onCreateNew}
          sx={{
            bgcolor: 'secondary.main',
            flex: 1,
            height: 56,
            px: 1,
          }}
          variant="button-outlined"
        >
          <AddRoundedIcon sx={{ color: 'surface.white', mr: spacing(0.5) }} />
          <Typography sx={{ color: 'surface.white', mt: '2px' }} variant="button">
            New Order
          </Typography>
        </MenuItem>
      )}
      <MenuItem
        component="button"
        onClick={({ currentTarget }) => {
          setMoreActive(!moreActive);
          setAnchor(currentTarget);
        }}
        sx={{
          flex: 1,
          height: 56,
          px: 1,
        }}
        variant="button-outlined"
      >
        <Typography sx={{ color: 'primary.main', mt: '2px' }} variant="button">
          More
        </Typography>
        {moreActive ? (
          <KeyboardArrowUpIcon sx={{ color: 'primary.main', ml: 1 }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ color: 'primary.main', ml: 1 }} />
        )}
        <Menu
          anchorEl={anchor}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          onClose={() => setMoreActive(false)}
          open={moreActive}
          transformOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
        >
          <Link style={{ textDecoration: 'none' }} to="../search">
            <MenuItem
              onClick={() => {
                handleClickViewList();
              }}
              sx={{
                ...typography.button,
                color: 'secondary.main',
                textDecoration: 'none',
                textTransform: 'none',
              }}
            >
              View List
            </MenuItem>
          </Link>
          <Link style={{ textDecoration: 'none' }} to="../search">
            <MenuItem
              onClick={() => {
                handleClickViewClosed();
              }}
              sx={{
                ...typography.button,
                color: 'secondary.main',
                textDecoration: 'none',
                textTransform: 'none',
              }}
            >
              View Closed
            </MenuItem>
          </Link>
        </Menu>
      </MenuItem>
      <Divider orientation="vertical" sx={{ height: 48, width: '1px' }} />
      <MenuItem
        // making type button so that testing works for disable/enable
        component="button"
        disabled={disableFilterButton}
        label="Filters"
        onClick={event => setFilterDrawerOpen(true, event)}
        sx={{
          flex: 1,
          height: 56,
          px: 1,
        }}
        variant="button-outlined"
      >
        <Typography sx={{ color: 'primary.main', mt: '2px' }} variant="button">
          Filters
        </Typography>
        {filterCount >= 1 && (
          <Typography
            component="span"
            sx={{
              alignItems: 'center',
              backgroundColor: 'primary.light',
              borderRadius: 2,
              color: 'primary.main',
              display: 'flex',
              fontSize: 12,
              height: 16,
              justifyContent: 'center',
              ml: 1,
              p: 2,
              width: 14,
            }}
          >
            {filterCount}
          </Typography>
        )}
        <ChevronRightRoundedIcon sx={{ ml: 1 }} />
      </MenuItem>
    </Toolbar>
  );
};

OpenPtosMobileMenuItems.propTypes = {
  affiliateListDropdown: arrayOf(shape({})).isRequired,
  filterCount: number.isRequired,
  handleClickViewClosed: func.isRequired,
  handleClickViewList: func.isRequired,
  locations: arrayOf(shape({})).isRequired,
  numberFuturePtos: number.isRequired,
  onCreateNew: func.isRequired,
  setFilterDrawerOpen: func.isRequired,
};

export default OpenPtosMobileMenuItems;
